//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation  } from "react-router-dom";

//css
import styled from "styled-components"

// component
import MyGrade from "./components/MyGrade"


export default function MyGradePage() {

    return (
        <MyGrade/>
    );
  }

